module.exports = __webpack_public_path__ + "img/add friend.2f4a306e.svg";